<template>
<div
    v-resize="onResize"
>
    <div
        :class="{ 'conversation_container' : true, 'container_with_sign_in_as_footer' : $rc.$state.showSignedInAsFooter() }"
        ref="conversation_container"
    >
        <div
            v-if="ad_hoc_dnd != null && ad_hoc_dnd != ''"
            style="text-align: center; margin: 10px; padding: 10px; background-color: #fafafa; border-radius: 20px; border: 1px solid #e8e8e8;"
        >
            You've put yourself into Do Not Disturb mode until {{ getDNDEndTime() }}. <a v-on:click="onExitDND">End now.</a>
        </div>

        <m-incident-banner
            ref="incident-banner"
        />

        <v-banner
            v-if="should_see_tmobile_warning && network_is_tmobile"
            icon="mdi-alert-outline"
            style="background-color: #FFCDD2"
            :sticky="true"
        >
            <h4
                class="text-center"
            >
                This conversation includes a T-Mobile phone number. Click <a @click="showTMobileWarningDetailsDialog">here</a> for info about the current T-Mobile deliverability issue.
            </h4>
        </v-banner>

        <v-banner
            v-if="opt_out_banner_text != null"
            style="background-color: #fafafa"
            :sticky="true"
        >
            <h4
                style="text-align: center"
            >
                {{opt_out_banner_text}}
            </h4>
        </v-banner>


        <m-home-conversation
            v-if="no_conversation_selected"
        />

        <!-- spacer to make the top of the conversation have some padding before it... -->
        <div style="height: 25px;">
        </div>

        <div
            v-if="messages != null && messages.length >= 100"
            style="text-align: center; margin-bottom: 15px;"
        >
            <a
                v-on:click="onClickLoadOlderMessages"
                style="text-decoration: underline"
            >
                older messages
            </a>
        </div>

        <m-conversation-line
            v-for="(message, index) in messages"
            :key="index"

            :message="message"
            :previous_message="getMessage(index-1)"
            :next_message="getMessage(index+1)"
            :for_endpoint="for_endpoint"
            v-on:message-details="onShowMessageDetails($event)"
            v-on:admin-edit-message="onClickAdminEditMessage"
            v-on:create-saved-message="$emit('create-saved-message',$event)"
            v-on:bulk-message-set-outcome="$emit('bulk-message-set-outcome',$event)"
            v-on:import-vcard="$emit('import-vcard', $event)"
            v-on:edit-scheduled-message="$emit('edit-scheduled-message', $event)"
            v-on:edit-note="onClickEditNote"
        />

         <!-- some padding at the bottom -->
        <div style="height: 15px;">
        </div>

        <div
            v-if="conversation != null && conversation.offset != 0"
            style="text-align: center; margin-bottom: 15px;"
        >
            <a
                v-on:click="onClickLoadNewerMessages"
                style="text-decoration: underline"
            >
                newer messages
            </a>
        </div>

        <m-conversation-is-typing
            ref="conversation-is-typing"
            v-if="conversation != null"
            :conversation_id="conversation.getConversationId()"
        />

        <div
            class="empty_conversation"
            v-if="conversation_empty"
            v-on="$rc.$state.isSystemsAdmin() ? { click: onCreateStub } : {}"
        >
            <div class="empty_conversation_text">
                Empty Conversation with {{sub_title}}
            </div>
        </div>


        <m-other-conversations
            v-if="conversation != null"
            :conversation_id="conversation.getConversationId()"
        />

        <div
            style="text-align: center; margin-bottom: 15px"
            v-if="should_introduce_yourself"
        >
            <v-btn
                color="primary"
                v-on:click="onClickSendIntro"
            >
                Introduce Yourself
            </v-btn>
        </div>

        <m-conversation-chips
            v-if="conversation_summary != null"
            :organization_id="conversation_summary.organization_id"
            :conversation_id="conversation_summary.conversation_id"
            v-on:scroll-to-bottom="scrollConversationToBottom"
        />

    </div>


    <form id="message-search-form" autocomplete="off" action="javascript:void(0);">
        <div
            :class="{ new_message_controls: true, new_message_controls_with_narrow_scrollbars: scroll_bar_width < 5, new_message_controls_with_sign_in_as_footer: $rc.$state.showSignedInAsFooter() }"
            v-show="show_message_controls"
            ref="message_controls"
        >
            <div
                class="message_container"
                ref="message_container"
            >
                <textarea
                    class="text_input_box"
                    size="1"
                    placeholder="Text message"
                    v-model="cur_text"
                    ref="text_input"
                    v-on:keydown="onMessageKeyDown"
                    v-on:input="onMessageBoxInput"
                    @focus="onFocusOnTextBox"
                />

                <div
                    :style="message_type_style"
                    v-if="$rc.$state.showMessageTypeIndicator()"
                >
                    {{message_type}}
                </div>

                <v-icon
                    size="25"
                    style="align-self: flex-end; margin-bottom: 3px; margin-right: 5px"
                    v-on:click="toggleEmojiSelector"
                >
                    mdi-emoticon-outline
                </v-icon>

                <v-menu
                    top
                    offset-y
                    max-height="90vh"
                >
                    <template v-slot:activator="{ on }">
                        <v-icon
                            size="25"
                            v-on="on"
                            style="align-self: flex-end; margin-bottom: 3px"
                        >
                            mdi-plus-circle-outline
                        </v-icon>
                    </template>

                    <v-list>
                        <v-list-item
                            v-on:click="onClickSendIntro"
                        >
                            <v-list-item-icon><v-icon>mdi-human-greeting-variant</v-icon></v-list-item-icon>
                            <v-list-item-title >Send introduction...</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-on:click="onClickSendVCard"
                        >
                            <v-list-item-icon><v-icon>mdi-card-account-details-outline</v-icon></v-list-item-icon>
                            <v-list-item-title>Send your contact information...</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-on:click="composeAttachment"
                        >
                            <v-list-item-icon><v-icon>mdi-image</v-icon></v-list-item-icon>
                            <v-list-item-title>Send pictures or files...</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-on:click="onClickSearchSavedMessages"
                        >
                            <v-list-item-icon><v-icon>mdi-message-draw</v-icon></v-list-item-icon>
                            <v-list-item-title>Saved messages...</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-on:click="onClickComposeMessage"
                        >
                            <v-list-item-icon><v-icon>mdi-lead-pencil</v-icon></v-list-item-icon>
                            <v-list-item-title>Compose message...</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-on:click="onClickScheduleMessage"
                        >
                            <v-list-item-icon><v-icon>mdi-alarm</v-icon></v-list-item-icon>
                            <v-list-item-title>Schedule message...</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-if="can_payment"
                            v-on:click="showPaymentRequestDialog"
                        >
                            <v-list-item-icon><v-icon>mdi-cash-multiple</v-icon></v-list-item-icon>
                            <v-list-item-title>Request a payment...</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-on:click="showOptOutDialog"
                        >
                            <v-list-item-icon><v-icon>mdi-account-group</v-icon></v-list-item-icon>
                            <v-list-item-title>Manually opt in or out...</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-on:click="sendOptInMessage"
                        >
                            <v-list-item-icon><v-icon>mdi-message-check-outline</v-icon></v-list-item-icon>
                            <v-list-item-title>Send opt in message...</v-list-item-title>
                        </v-list-item>

                         <v-list-item
                            v-on:click="showOutboundCallDialog"
                            v-if="$rc.$state.provisionOutboundCalling()"
                        >
                            <v-list-item-icon><v-icon>mdi-phone</v-icon></v-list-item-icon>
                            <v-list-item-title>Place a call...</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-on:click="onClickFollowConversation"
                        >
                            <v-list-item-icon><v-icon>mdi-map-marker-outline</v-icon></v-list-item-icon>
                            <v-list-item-title>Follow Conversation...</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-on:click="onClickCreateContactRequest"
                        >
                            <v-list-item-icon><v-icon>mdi-card-account-mail</v-icon></v-list-item-icon>
                            <v-list-item-title>Create contact request...</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-on:click="toggleArchiveConversation"
                            v-if="conversation_summary != null && conversation_summary.state != 'spam'"
                        >
                            <v-list-item-icon><v-icon>mdi-archive-arrow-down</v-icon></v-list-item-icon>
                            <v-list-item-title>{{archive_text}}</v-list-item-title>
                        </v-list-item>

                        <m-restricted-menu-list-item
                            v-if="can_test"
                            v-on:click="showTestMessageDialog"
                            text="Test message..."
                            icon="mdi-xml"
                        />

                        <v-list-item
                            v-on:click="showCopyConversationDialog"
                        >
                            <v-list-item-icon><v-icon>mdi-content-copy</v-icon></v-list-item-icon>
                            <v-list-item-title>Copy conversation...</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-for="(integration, integration_index) in $rc.$state.getCurrentAdfIntegrations()"
                            :key="integration_index"
                            v-on:click="onAdfSendConversation(integration)"
                        >
                            <v-list-item-icon><v-icon>mdi-folder-account-outline</v-icon></v-list-item-icon>
                            <v-list-item-title>Send conversation to {{integration.system_label}}...</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-if="$rc.$state.isCommerce7Enabled()"
                            v-on:click="onClickViewInCRM('commerce7')"
                        >
                            <v-list-item-icon><v-icon>mdi-vector-link</v-icon></v-list-item-icon>
                            <v-list-item-title>View in Commerce7...</v-list-item-title>
                            <v-list-item-icon v-on:click="onClickCommerce7OpenInSettings" @click.stop><v-icon>mdi-cog</v-icon></v-list-item-icon>
                        </v-list-item>

                        <v-list-item
                            v-if="$rc.$state.isECellarEnabled()"
                            v-on:click="onClickViewInCRM('ecellar')"
                        >
                            <v-list-item-icon><v-icon>mdi-vector-link</v-icon></v-list-item-icon>
                            <v-list-item-title>View in eCELLAR...</v-list-item-title>
                        </v-list-item>

                         <v-list-item
                            v-if="$rc.$state.isWineDirectEnabled()"
                            v-on:click="onClickViewInCRM('winedirect')"
                        >
                            <v-list-item-icon><v-icon>mdi-vector-link</v-icon></v-list-item-icon>
                            <v-list-item-title>View in WineDirect...</v-list-item-title>
                        </v-list-item>

                       <v-list-item
                            v-if="$rc.$state.isVinSuiteEnabled()"
                            v-on:click="onClickViewInCRM('vinsuite')"
                        >
                            <v-list-item-icon><v-icon>mdi-vector-link</v-icon></v-list-item-icon>
                            <v-list-item-title>View in vinSUITE...</v-list-item-title>
                        </v-list-item>
                        
                       <v-list-item
                            v-if="$rc.$state.isBottle360Enabled()"
                            v-on:click="onClickViewInCRM('bottle360')"
                        >
                            <v-list-item-icon><v-icon>mdi-vector-link</v-icon></v-list-item-icon>
                            <v-list-item-title>View in Bottle360...</v-list-item-title>
                        </v-list-item>
                        
                        <v-list-item
                            v-if="can_forward"
                            v-on:click="onClickForward"
                        >
                            <v-list-item-icon><v-icon>mdi-share</v-icon></v-list-item-icon>
                            <v-list-item-title>Forward...</v-list-item-title>
                        </v-list-item>

                        <v-list-item
                            v-on:click="onClickAddNote"
                        >
                            <v-list-item-icon><v-icon>mdi-note</v-icon></v-list-item-icon>
                            <v-list-item-title>Add note...</v-list-item-title>
                        </v-list-item>

                    </v-list>
                </v-menu>
            </div>

            <div class="send_container">
                <v-icon v-on:click="sendText">mdi-send-outline</v-icon>
            </div>
        </div>


    </form>

    <m-copy-conversation-dialog
        ref="copy-conversation-dialog"
    />

    <m-adf-choose-method-dialog
        ref="adf-chose-method-dialog"
    />

    <m-dialog-admin-edit-message
        ref="dialog-admin-edit-message"
    />

    <m-create-bulk-opt-out-dialog
        ref="bulk-opt-out-dialog"
        v-on:upsert_bulk_opt_out="onChangeOptOutStatus"
    />



    <m-integration-crm-select-customer-dialog
        ref="integration-crm-select-customer-dialog"
    />

    <m-dialog-follow-conversation
        ref="follow-conversation-dialog"
    />

    <m-dialog-forward-contact-request
        ref="dialog-forward-contact-request"
    />

    <m-introduction-dialog
        ref="dialog-introduction"
        v-on:customize="onCustomizeIntro"
    />

    <m-choose-vcard-dialog
        ref="choose-vcard-dialog"
        title="Choose contact card to send"
        action_text="Send this contact card"
        v-on:input='onSendVCard'
        text_with_action
    />

    <m-create-contact-request-dialog
        ref="create-contact-request-dialog"
        v-on:ok="onCreateNewContactRequest($event)"
        in_conversation
    />

    <m-edit-note-dialog
        ref="edit-note-dialog"
    />

</div>
</template>

<script>



const Utils = require('@/js/utils.js');
const Time = require('@/js/time.js');

export default {
    props: {
        for_endpoint: {
            type: String,
            default: function()
            {
                return '';
            }
        },
        org_endpoint: {
            type: Object,
            default: function()
            {
                return null;
            }
        },
        show_message_controls: {
            type: Boolean,
            default: function()
            {
                return true;
            }
        },

        can_transmit: {
            type: Boolean,
            default: () => { return true; }
        },

        sub_title: {
            type: String,
            default: () => { return ''; }
        },

        no_conversation_selected: {
            type: Boolean,
            default: () => { return false; }
        },
        ad_hoc_dnd: {
            type: Object,
            default: () => { return null;}
        },
    },
    data() {
        return {
            last_conversation_id: null,
            messages: [],
            conversation: null,
            conversation_summary: null,
            scroll_bar_width: 16,
            cur_text: null,
            show_emoji_selector: true,
            last_calc_message_box_height: -1,
            consent_summary: null,
            validation_network_name: null,
        }
    },
    mounted () {
        this.onResize();
    },

    methods: {

        toggleEmojiSelector()
        {
            this.$rc.simplePickEmoji(
                (value) => {
                    this.appendCurrentText(value);
                }
            );
        },

        checkOptOutStatus()
        {
            if (this.conversation == null) return;

            let params = {
                'organization_id': this.conversation.conversation_definition.organization_id,
                'endpoint': this.get_other_endpoint,
            };

            this.$rc.rest(
                'LIST: /api/v1/consent/current-state-one-endpoint',

                params,

                (data) => {
                    this.consent_summary = data;
                },

                () => {
                    this.consent_summary = null;
                },
            );
        },

        onChangeOptOutStatus() {
            this.checkOptOutStatus();
        },

        checkNetworksForTMobile()
        {
            if (this.conversation == null) return;

            let params = {
                'organization_id': this.conversation?.conversation_definition?.organization_id,
                'endpoint': this.get_other_endpoint,
            };

            this.$rc.rest(
                'GET: /api/v1/numbers/:organization_id/:endpoint/validation-network-name',

                params,

                (data) => {
                    this.validation_network_name = data.validation_network_name;
                },

                () => {
                    this.validation_network_name = null;
                },
            );
        },

        showTMobileWarningDetailsDialog()
        {
            this.$rc.alert(
                'Important Notice: T-Mobile Message Delivery Issue',
                "<p>T-Mobile is currently experiencing an issue affecting message delivery to T-Mobile numbers.</p><ul><li>Your messages to T-Mobile phone numbers are probably not arriving on those T-Mobile handsets.</li><li>Incoming messages from T-Mobile numbers, to you, are being received without incident.</li><li>Outgoing messages to all other carriers' phone numbers are arriving without incident.</li></ul><p></p><p>The issue lies downstream of what RedChirp controls, but we've escalated the matter to senior management with those downstream carriers. We're in regular contact as they work on this issue. We will continue to monitor, test, and advocate for urgency.</p><p>Thank you for your patience as we push for a resolution.</p>"
            );
        },

        getDNDEndTime() {
            return Time.getPeriodClockTime(this.ad_hoc_dnd.time_stop);
        },

        onExitDND() {
            this.$emit('exit-dnd','');
        },

        getMessage(index) {
           if ( index < 0 ) return null;
           if ( index >= this.messages.length ) return null;
           return this.messages[index];
        },

        update(conversation)
        {
            this.conversation = conversation;
            this.messages = conversation.asArray().reverse();
            this.conversation_summary = this.getConversationSummary();
            this.checkOptOutStatus();
            this.checkNetworksForTMobile();

            if ( this.$refs['incident-banner'] != null )
                this.$refs['incident-banner'].update();
        },

        getConversationSummary()
        {
            if (!this.conversation || !this.conversation.conversation_definition) return;

            this.$rc.getConversationSummary(
                this.for_endpoint,
                this.conversation.conversation_definition.conversation_id,
                (data) => {
                    if (data != null && data.summaries)
                    {
                        this.conversation_summary = data.summaries[0];
                    }
                }
            );
        },

        getConversationId(default_value)
        {
            if ( this.conversation == null )
                return default_value;

            return this.conversation.getConversationId();
        },

        onResize()
        {
            this.scroll_bar_width = Utils.getScrollbarWidth();
        },

        onMessageKeyDown(event)
        {
            if ( event.keyCode == 13 && !event.shiftKey && window.innerWidth > 960  )
            {
                event.stopPropagation();
                event.preventDefault();
                this.sendText();
            }

            this.$refs['conversation-is-typing'].updateIsTyping(
                this.for_endpoint,
                this.conversation.getConversationId(null),
                this.$rc.$state.profile.employee_contact,
                true,
            );
        },

        sendText() {

            this.$emit('send-message',this.cur_text.trim());
            window.setTimeout(() => { this.clearMessageText(); },200);

            this.$refs['conversation-is-typing'].updateIsTyping(
                this.for_endpoint,
                this.conversation.getConversationId(null),
                this.$rc.$state.profile.employee_contact,
                false,
            );
        },

        clearMessageText(focus)
        {
            this.cur_text = '';

            window.setTimeout(() => {
                this.onMessageBoxInput();
                if ( focus ) this.$refs['text_input'].focus();
            }, 100);
        },

        appendCurrentText(text_to_append)
        {
            if ( this.cur_text == null )
            {
                this.cur_text = '';
            }

            this.cur_text += text_to_append;
            window.setTimeout(() => {
                this.onMessageBoxInput();
                if ( focus ) this.$refs['text_input'].focus();
            }, 100);
        },

        setCurrentText(new_text)
        {
            this.cur_text = new_text;
            window.setTimeout(() => {
                this.onMessageBoxInput();
                if ( focus ) this.$refs['text_input'].focus();
            }, 100);
        },

        onClickSendIntro()
        {
            this.$refs['dialog-introduction'].showDialog();
        },

        onClickSendVCard()
        {
            this.$refs['choose-vcard-dialog'].showDialog(
                {
                    'organization_id': this.conversation.conversation_definition.organization_id,
                    'for_organization_owned_endpoint' : this.for_endpoint,
                },
            );
        },

        onSendVCard(vcard)
        {
            if ( this.conversation_id === null )
                return;

            let to_send = {
                'active_endpoint': this.for_endpoint,
                'conversation_id': this.conversation.conversation_definition.conversation_id,
                'text': vcard.text.trim(),
                'blob_ids': null,
                'send_images_as_links': null,
                'category': 'conversational',
                'vcard': vcard,
            };

            this.$rc.sendMessage(to_send);
        },

        composeAttachment()
        {
            this.$emit('compose-attachment',this.cur_text);
            this.clearMessageText();
        },

        onCustomizeIntro(send_data)
        {
            this.$emit('customize-intro',send_data);
            this.clearMessageText();
        },

        onClickComposeMessage()
        {
            this.$emit('compose-message',this.cur_text);
            this.clearMessageText();
        },

        onClickScheduleMessage()
        {
            this.$emit('schedule-message',this.cur_text);
            this.clearMessageText();
        },

        onClickFollowConversation()
        {
            this.$refs['follow-conversation-dialog'].showDialog();
        },

        onClickSearchSavedMessages()
        {
            this.$emit('search-saved-messages');
        },

        showPaymentRequestDialog()
        {
            this.$emit('show-payment-request-dialog');
        },

        scrollConversationToBottom()
        {
            let element = this.$refs['conversation_container'];
            element.scrollTop = element.scrollHeight - element.clientHeight;
        },

        showOutboundCallDialog()
        {
            this.$emit('show-start-outbound-call-dialog',this.cur_text);
        },

        onFocusOnTextBox()
        {
            this.$emit('start-entering-text');

            this.$refs['conversation-is-typing'].updateIsTyping(
                this.for_endpoint,
                this.conversation.getConversationId(null),
                this.$rc.$state.profile.employee_contact,
                true,
            );

            window.setTimeout(this.scrollTextAreaIntoView,150);
            window.setTimeout(this.scrollTextAreaIntoView,300);
            window.setTimeout(this.scrollTextAreaIntoView,450);
            window.setTimeout(this.scrollTextAreaIntoView,600);
        },

        scrollTextAreaIntoView()
        {
            this.$refs['text_input'].style.bottom = '100px';
        },

        focusOnTextBox()
        {
            window.setTimeout(() => { this.$refs['text_input'].focus();} , 150);
        },

        onShowMessageDetails(stored_message_id)
        {
            this.$emit('message-details',stored_message_id);
        },

        toggleArchiveConversation()
        {
            let new_state = null;

            if ( this.conversation_summary.state == 'active' )
            {
                new_state = 'archived';
            }

            if ( this.conversation_summary.state == 'archived' )
            {
                new_state = 'active';
            }

            if ( new_state == null )
                return;


            this.$rc.showSpinner();

                this.$rc.rest(
                    'PUT: /api/v1/conversations/set-state',

                    {
                        'endpoint' : this.for_endpoint,
                        'conversation_id' : this.conversation.getConversationId(null),
                        'state' : new_state
                    },

                    (data) => {
                        this.$rc.hideSpinner();
                    },

                    () => {
                        this.$rc.hideSpinner();
                        this.$rc.alert('Error','Unable to modify conversation');
                    },
                );
        },



        showTestMessageDialog()
        {
            this.$emit('test-message');
        },

        showOptOutDialog()
        {
            this.$refs['bulk-opt-out-dialog'].showDialog(
                this.conversation.conversation_definition.organization_id,
                this.get_other_endpoint
            );
        },

        sendOptInMessage()
        {
            this.$rc.showSpinner();

            this.$rc.rest(
                'GET: /api/v1/consent/consent-agreement-message/:organization_id',

                {
                    'organization_id': this.conversation.conversation_definition.organization_id,
                },

                (data) => {
                    this.$rc.hideSpinner();

                    this.$rc.confirm(
                        'Send opt-in message',
                        'The following message will be sent:<br/><br/><b>'+data.text+"</b><br/><br/>A reply of YES will opt "+this.sub_title+" in for conversational, informational and promotional messages.",
                        [
                            {'text': 'Cancel', 'value': 'cancel'},
                            {'text': 'Send', 'value': 'confirm'},
                        ],

                        (response) => {
                            if (response != 'confirm') return;

                            this.doSendOptInMessage();
                        }
                    );
                },

                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },

        doSendOptInMessage()
        {
            this.$rc.showSpinner();

            this.$rc.rest(
                'PUT: /api/v1/consent/send-consent-agreement',

                {
                    'conversation_id' : this.conversation.getConversationId(),
                    'from' : this.for_endpoint,
                },

                (data) => {
                    this.$rc.hideSpinner();
                },

                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to send opt in message');
                },
            );
        },

        onAdfSendConversation(integration)
        {
            let params = {
                'integration_id' : integration.integration_id,
                'conversation_id' : this.conversation.getConversationId(),
                'active_endpoint' : this.for_endpoint,
            };

            this.$refs['adf-chose-method-dialog'].showDialog(params);
        },

        onClickAddNote()
        {
            this.$refs['edit-note-dialog'].showCreateNoteDialog(this.conversation.getConversationId(), this.for_endpoint);
        },

        onClickEditNote(stored_message_id)
        {
            this.$refs['edit-note-dialog'].showEditNoteDialog(stored_message_id);
        },

        onClickViewInCRM(content_type)
        {
            this.$rc.showSpinner();

            let crm_name = this.$rc.pretty(content_type, 'integration_name');

            this.$rc.rest(
                'LIST: /api/v1/integrations/crm/customers/from-conversation',

                {
                    'content_type' : content_type,
                    'conversation_id' : this.conversation.getConversationId(),
                },

                (data) => {
                    this.$rc.hideSpinner();

                    let results = data.results;
                    if ( results.length == 0 )
                    {
                        this.$rc.alert('No customer in '+crm_name,'No customer for this contact exists in '+crm_name);
                        return;
                    }

                    if ( results.length == 1 )
                    {
                        window.open(results[0].url_view_customer_in_crm);
                        return;
                    }

                    // Dialog...
                    this.$refs['integration-crm-select-customer-dialog'].showDialog(crm_name,data.results);
                },

                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to search '+crm_name+' customers');
                },
            );
        },



        onClickCommerce7OpenInSettings()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/employees/obscure-settings/:employee_id',

                'params' : {
                        'employee_id': this.$rc.$state.getEmployeeId()
                    },

                'on_success': (data) => {
                        this.onClickCommerce7OpenInSettingsWithInitialValue(data.commerce7_customer_profile_open_in ?? 'pos');
                    },

                'on_error': 'Unable to get your open in settings',
            });
        },

        onClickCommerce7OpenInSettingsWithInitialValue(initial_value)
        {
            this.$rc.pick({
                'title': 'Setting: Open Commerce7 Customer In',
                'content_before': 'Choose if the commerce7 customer should be opened in the admin or pos view',
                'content_after': 'This settings is specific to you (and will not apply to other users in your organization)',

                'choices': this.$rc.enumChoices('commerce7_customer_profile_open_in', false),

                'multiple': false,
                'type': 'select',
                'select_label': 'Choose One',
                'initial_value': initial_value,
                'unset_label': null,

                'on_ok': (value) => {
                    this.onSetCommerce7OpenInSettings(value);
                },

                'on_cancel': () => {}
            });
        },

        onSetCommerce7OpenInSettings(value)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PATCH: /api/v1/employees/obscure-settings',

                'params' : {
                        'employee_id': this.$rc.$state.getEmployeeId(),
                        'commerce7_customer_profile_open_in': value
                    },

                'on_success': (data) => {
                        this.$rc.snackbar('You settings have been updated', 1500);
                    },

                'on_error': 'Unable to update settings',
            });
        },

        showCopyConversationDialog()
        {
            this.$refs['copy-conversation-dialog'].showDialog(this.conversation.getConversationId());
        },

        onMessageBoxInput()
        {
            // only launch the saved message search if the only text is a single hashtag (otherwise, we don't
            // want to launch the search in the middle of their message)
            if ( this.cur_text != null &&  this.cur_text == '#' )
            {
                this.$emit('search-saved-messages');
            }

            let field = this.$refs['text_input'];

            field.style.height = '31px';

            let computed = window.getComputedStyle(field);

            // Calculate the height
            let height = parseInt(computed.getPropertyValue('border-top-width'), 10)
                + parseInt(computed.getPropertyValue('padding-top'), 10)
                + field.scrollHeight
                + parseInt(computed.getPropertyValue('padding-bottom'), 10)
                + parseInt(computed.getPropertyValue('border-bottom-width'), 10);


            field.style.height = height + 'px';

            let container = this.$refs['message_container'];
            container.style.height = (height + 14)+'px';

            let message_controls = this.$refs['message_controls'];
            message_controls.style.height = (height+34)+'px';

            this.last_calc_message_box_height = height;
        },

        onClickAdminEditMessage(message)
        {
            this.$refs['dialog-admin-edit-message'].showDialog(message);
        },

        onCreateStub()
        {
            if ( !this.$rc.$state.isSystemAdmin() ) return;

            if ( confirm("Staff Only: Create a fake message?") )
            {
                let data = {
                    'conversation_id' : this.conversation.getConversationId(),
                    'endpoint' : this.for_endpoint,
                    'content' : 'Conversation Starter!',
                };

                this.$rc.adminNewStoredMessage(
                    data,

                    (data) => {
                    },

                    () => {
                        this.$rc.alert('Error','Unable to add message');
                    },
                );
            }
        },

        onClickForward()
        {
            this.$refs['dialog-forward-contact-request'].showDialog(this.conversation.getConversationId());
        },

        onClickCreateContactRequest()
        {
            this.$refs['create-contact-request-dialog'].showDialog(
                this.conversation.conversation_definition.organization_id,
                this.get_other_endpoint,
                this.conversation.getConversationId(),
            );
        },

        onCreateNewContactRequest(info)
        {
            let contact_request = {
                'organization_id' : this.conversation.conversation_definition.organization_id,
                'contact_request_id' : this.$rc.uuidv4(),
                'assign_to_employee_ids' : info.assign_to_employee_ids,
                'created_by_employee_id' : this.$rc.$state.getEmployeeId(),
                'customer_name' : info.customer_name,
                'customer_endpoint' : info.customer_endpoint,
                'message' : info.message,
                'blob_ids' : info.blob_ids,

                'active_endpoint': this.for_endpoint,
                'conversation_id': this.conversation.getConversationId(),
                'archive_conversation': info.archive_conversation,
                'add_note_to_conversation': info.add_note_to_conversation,
            };

            this.show_spinner = true;

            this.$rc.createEmployeeContactRequest(
                contact_request,

                () => {
                    this.$rc.snackbar('New contact request created',3500);
                },

                () => {
                    this.$rc.alert('Error', 'Unable to create contact request');
                }
            )
        },

        onClickLoadOlderMessages()
        {
            this.$emit('change-offset', {
                'offset': this.conversation.offset + 100,
                'limit': this.conversation.limit
            });
        },

        onClickLoadNewerMessages()
        {
            let offset = this.conversation.offset - 100;
            if ( offset < 0 ) offset = 0;

            this.$emit('change-offset', {
                'offset': offset,
                'limit': this.conversation.limit
            });
        },

    },
    computed: {
        // this function only makes sense with the teams functionality

        can_payment() {
            return this.$rc.$state.profile.employee_account.payment_permissions != 'no-access';
        },

        can_test() {
            return this.$rc.$state.profile.employee_account.is_system_admin == true;
        },

        conversation_empty() {
            return (this.messages == null || this.messages.length == 0) && !this.no_conversation_selected;
        },

        get_other_endpoint() {
            if (this.conversation == null) return null;

            for (let i=0; i < this.conversation.conversation_definition.endpoints.length; i++)
            {
                // should only have two numbers, but just in case it expands in the future
                if (this.conversation.conversation_definition.endpoints[i] != this.for_endpoint)
                {
                    return this.conversation.conversation_definition.endpoints[i];
                }
            }

            return null;
        },

        archive_text()
        {
            if (this.conversation_summary == null) return "Archive";

            return this.conversation_summary.archived ? "Unarchive" : "Archive";
        },

        can_forward() {
            return this.$rc.$state.profile.can_forward_contact_request;
        },

        message_type()
        {
            return this.$rc.messageType(this.cur_text);
        },

        message_type_style()
        {
            let bottom = 65;

            if ( this.last_calc_message_box_height > 0)
            {
                bottom = (65-31)+this.last_calc_message_box_height;
            }

            return "color: rgba(0,0,0,0.8); font-size: 10px; margin-right: 5px; position: absolute; bottom: "+bottom+"px;";
        },

        has_pending_double_opt_in()
        {
            if ( this.consent_summary == null )
                return false;

            return this.consent_summary.has_pending_double_opt_in;
        },

        opt_out_banner_text()
        {
            if ( this.consent_summary == null )
                return null;

            let categories = [];

            if ( this.consent_summary.conversational == 'deny' ) categories.push('conversational');
            if ( this.consent_summary.informational == 'deny' ) categories.push('informational');
            if ( this.consent_summary.promotional == 'deny' ) categories.push('promotional');

            if ( categories.length == 0 )
                return null;

            if ( this.has_pending_double_opt_in && categories.includes('promotional') )
            {
                return this.sub_title+' is opted out of promotional messages, pending double opt in';
            }

            if (  categories.length == 3 )
            {
                return this.sub_title+' has opted out of all texting';
            }

            return this.sub_title+' has opted out of '+this.$rc.pretty(categories, 'comma_and_list') + ' messages';
        },

        // @CodeExpires('2024-12-01')
        should_see_tmobile_warning()
        {
            return this.$rc.shouldSeeTmobileWarning(this.conversation?.conversation_definition?.organization_id, this.for_endpoint);
        },

        // @CodeExpires('2024-12-01')
        network_is_tmobile()
        {
            return this.$rc.networkIsTmobile(this.validation_network_name) ||
                   this.get_other_endpoint == 'E164:+16027260324'; // Sandra Smithington
        },

        should_introduce_yourself()
        {
            if ( this.conversation == null )
                return false;

            for ( let i = 0; i < this.conversation.length(); i++ )
            {
                let cur = this.conversation.get(i);

                if ( (''+cur.getAuthor()).includes(this.for_endpoint) )
                    return false
            }

            return true;
        },
    },

    watch: {
        no_conversation_selected: function(val) {
            this.messages = [];
            this.conversation  = null;
            this.conversation_summary = null;
        },
    },


}
</script>

<style scoped>

.conversation_container
{
    position: fixed;
    top: 45px;
    bottom: 0;
    left: 350px;
    right: 0px;
    overflow-y: scroll;
    overflow-x: hidden;
    scrollbar-width: thin;

    padding-bottom: 75px;

    z-index: 1;

    background-color: white;

}


@supports (-moz-padding-end: initial) {
    .conversation_container {
        bottom: 80px;
    }
}

.container_with_sign_in_as_footer
{
    bottom: 30px;
}

.new_message_controls
{
    position: fixed;
    bottom: 5px;
    height: 65px;
    left: 366px;
    right: 15px;

    display: flex;

    padding-left: 0px;
    padding-right: 0px;

    z-index: 2;
}

.new_message_controls_with_sign_in_as_footer
{
    bottom: 35px;
}

.new_message_controls_with_narrow_scrollbars
{
    right: 11px;
}

@media screen and (max-width: 960px)
{
    .conversation_container
    {
        left: 0px;
        right: 0px;
    }

    .new_message_controls
    {
        left: 16px;
    }
}

.chip_bar
{
    flex-grow: 1;
    display: flex;
}

.admin-clickable {
    cursor: pointer;
    text-decoration: underline;
}


.message_container
{
    flex-grow: 1;

    background-color: white;
    border-bottom-left-radius: 26px;
    border-bottom-right-radius: 26px;
    border-top-right-radius: 26px;
    border-top-left-radius: 26px;
    z-index: 1;
    height: 45px;

    box-shadow: rgba(60,64,64,0.15) 0px 1px 5px 0px, rgba(60,64,64,0.1) 0px 4px 4px 0px, rgba(60, 64, 64, 0.08) 0px -0.1px 3px 0px;
    padding-top: 7px;
    padding-bottom: 7px;

    padding-left: 25px;
    padding-right: 14px;

    margin-top: 5px;
    margin-left: 10px;
    margin-right: 10px;

    display: flex;

    min-width: 1px;
}

.send_container
{
    flex-grow: 0;

    align-self: flex-end;
    margin-bottom: 15px;

    background-color: white;
    border-bottom-left-radius: 26px;
    border-bottom-right-radius: 26px;
    border-top-right-radius: 26px;
    border-top-left-radius: 26px;
    z-index: 1;
    height: 45px;

     box-shadow: rgba(60,64,64,0.15) 0px 1px 5px 0px, rgba(60,64,64,0.1) 0px 4px 4px 0px, rgba(60, 64, 64, 0.08) 0px -0.1px 3px 0px;
    padding-top: 10px;
    padding-bottom: 7px;

    min-width: 45px;

    margin-top: 5px;
    margin-left: 0px;
    margin-right: 10px;
    padding-left: 12px;
}

.text_input_box
{
    flex-grow: 1;
    font-family: Roboto, "Helvetica Neue", sans-serif, NotoColorEmoji, "apple color emoji", "windows emoji", "windows symbol";
    font-size: 16px;
    outline: none;
    resize: none;
    margin-top: 3px;
}

.empty_conversation
{
    position: absolute;
    bottom: 100px;
    left: 0px;
    right: 0px;
    height: 25px;
    text-align: center;
}

.empty_conversation_text
{
    display: inline-block;
    padding: 10px;
    font-family: Roboto, "Helvetica Neue", sans-serif, NotoColorEmoji, "apple color emoji", "windows emoji", "windows symbol";
    font-size: 12px;
    margin: 0 auto;
    background-color: #f8f9fa;
    color: #5f6368;
}

</style>
